import React from 'react';
import PropTypes from 'prop-types';

import SrButton, { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrStaticFooter from 'client/components/SrStaticFooter';
import SrSecureTextLabel from 'client/components/SrSecureTextLabel';

const UPConnectBankAccountFormFooter = ({ buttonText, buttonTheme, onNext, disabled }) => {
  return (
    <SrStaticFooter>
      <SrButton
        theme={buttonTheme || SR_BUTTON_THEME_ADOBE_GREEN}
        onClick={onNext}
        disabled={disabled}
        width="100%"
        hasBoxShadow
      >
        {buttonText}
      </SrButton>
      <SrBox margin="3px auto 0">
        <SrSecureTextLabel>Secure Connection</SrSecureTextLabel>
      </SrBox>
    </SrStaticFooter>
  );
};

UPConnectBankAccountFormFooter.propTypes = {
  buttonText: PropTypes.string,
  buttonTheme: PropTypes.string,
  onNext: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

UPConnectBankAccountFormFooter.defaultProps = {
  buttonText: 'Next',
};

UPConnectBankAccountFormFooter.displayName = 'UPConnectBankAccountFormFooter';

export default UPConnectBankAccountFormFooter;
